export interface IValueWithValidation {
    value: string,
    valid: boolean
}